import { ICompetitionCalendarResults } from '@sky-it-livedata/livedata-sports-design-system';
import React, { Suspense } from 'react';

import { IComponentModel } from '../../typings/common-types';
import { validateModel } from '../../utils/props-validator';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const CompetitionCalendarResultsWrapper = React.lazy(() => import('./competition-calendar-results'));

export interface IDynamicCompetitionCalendarResults extends IComponentModel<ICompetitionCalendarResults> {
  // eslint-disable-next-line react/require-default-props
  live?: boolean;
}

/* TODO: Consider transform this code to generic HOC
  I need to understand how lo lazy load a generic component in HOC
  const MyComponent = React.lazy(() => import('my-component-path'));
 */
const DynamicCompetitionCalendarResults = ({
  /* istanbul ignore next: default value */ model = {} as ICompetitionCalendarResults,
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
}: IDynamicCompetitionCalendarResults) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <CompetitionCalendarResultsWrapper
      live={live}
      initialModel={validateModel(model) as ICompetitionCalendarResults}
      query={validateModel(query)}
    />
  </Suspense>
);

export default DynamicCompetitionCalendarResults;
